module.exports = __webpack_public_path__ + "static/logo-c6c456e6b3ae6755354f4dcdf57fd76f.png";